import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { InputDropdown } from '../../../../common/html/input/InputDropdown'
import { Notification } from '../../../../common/notification'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { removeAccents } from '../../../../helpers/common'
import { Z_INDEX } from '../../../../utils/common'
import { selectCustomProfileList } from '../../store/slice'
import { getProfileDetail } from '../../store/thunk'
import classes from '../index.module.scss'
import { selectOtherSetting } from '../store/slice'

export const SelectProfile = () => {
  const dispatch = useDispatch()

  const listProfileCustom = useSelector(selectCustomProfileList)

  const [keyword, setKeyword] = useState('')
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const data = useSelector(selectOtherSetting(''))

  const profileList = listProfileCustom.filter((item) =>
    removeAccents(item.profileName.toLowerCase()).includes(
      removeAccents(keyword.trim().toLowerCase()),
    ),
  )

  const onChange = (e) => {
    setKeyword(e.target.value)
  }

  const onClick = () => {
    setKeyword('')
    setIsShowDropdown(true)
  }

  const onClickOutsideDropdown = () => {
    setKeyword(data?.profileName || '')
    setIsShowDropdown(false)
  }

  const handleChooseProfile = async (item) => {
    dispatch(
      getProfileDetail({
        AlertProfileId: item?.alertProfileId,
      }),
    )
    setIsShowDropdown(false)
  }

  useEffect(() => {
    setKeyword(data?.profileName || '')
  }, [data])

  return (
    <div className="ml3 mt2">
      <InputDropdown
        isShowDropdown={isShowDropdown}
        onClickOutsideDropdown={onClickOutsideDropdown}
        inputProps={{
          onClick,
          value: keyword,
          onChange,
          placeHolder: 'alertSetting.PROFILE_NAME_RULES',
          style: { paddingRight: 16 },
          containerStyle: { width: '100%', display: 'flex' },
          isShowLabel: true,
          isShowIcon: false,
          customElement: (
            <Icon
              className="icon-caret-bottom pointerEventsNone"
              style={{
                fontSize: 8,
                left: 'unset',
                right: 4,
              }}
            />
          ),
        }}
        zIndexDropdown={Z_INDEX.MODAL + 1}
      >
        <ScrollComponent autoHeight autoHeightMax={200}>
          <div className={classes.profileList}>
            {profileList.length ? (
              profileList.map((item, index) => (
                <Element
                  key={index}
                  onClick={() => handleChooseProfile(item)}
                  className={classes.profileItem}
                  style={{ borderColor: '#D5D5D5' }}
                >
                  {item.profileName}
                </Element>
              ))
            ) : (
              <Notification />
            )}
          </div>
        </ScrollComponent>
      </InputDropdown>
    </div>
  )
}
